import { render, staticRenderFns } from "./binding-module.vue?vue&type=template&id=9a5e4afc"
import script from "./binding-module.vue?vue&type=script&lang=js"
export * from "./binding-module.vue?vue&type=script&lang=js"
import style0 from "./binding-module.vue?vue&type=style&index=0&id=9a5e4afc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports